const ruleTypes = {
    INCLUDED: 'OR',
    EXCLUDED: 'NOT',
};

export default ruleTypes;
